const BEDROOM = {

  id: "bedroom",
  type: "dropdown",
  props: {
    isMulti: true,
    dropdownProps: {
      label: "Bedroom",
      buttonProps: {
        className: "bedroom",
      },
      menuProps: {
        style: {
          // minWidth: 300
        }
      }
    },
    options: [
      { label: "Studio", value: 0, field: "studio_price" },
      { label: "1-Bedroom", value: 1, field: "1br_price" },
      { label: "2-Bedroom", value: 2, field: "2br_price" },
      { label: "3-Bedroom", value: 3, field: "3br_price" },
      { label: "4-Bedroom", value: 4, field: "4br_price" },
      { label: "5-Bedroom", value: 5, field: "5br_price" },
      { label: "6-Bedroom", value: 6, field: "6br_price" },
      { label: "Penthouse", value: "Penthouse", field: "penthouse_price" },
    ],
  }

}

const COL_BEDROOM = {

  id: "col_bedroom",
  type: "col",
  props: {
    lg: 3,
    md: 4,
    xs: 6,
  },
  children: [BEDROOM]

}

const COL_MODAL_BEDROOM = {

  id: "col_bedroom",
  type: "col",
  props: {
    lg: 6,
    md: 6,
    xs: 6,
  },
  children: [BEDROOM]

}

export { BEDROOM, COL_BEDROOM, COL_MODAL_BEDROOM };
